export default function EmployeesController(
  $stateParams,
  $scope,
  $translate,
  roleHelper,
  employeesService,
  merchantService,
  NotificationService,
  MERCHANT_PRODUCTS,
) {
  var vm = this;

  vm.merchantId = $stateParams.merchantId;
  vm.employees = [];
  vm.merchant = {};
  vm.isLoading = true;
  vm.addEmployeeEnabled = false;

  vm.init = init;

  var listener = $scope.$on('merchant.tab.employees.selected', vm.init);
  $scope.$on('merchant.configuration.updated', getMerchant);

  function init() {
    listener();
    getEmployees();
  }

  function getEmployees() {
    vm.isLoading = true;
    employeesService
      .getEmployees(vm.merchantId)
      .then(function(res) {
        vm.employees = res.data.employees.map(function(employee) {
          if (employee.role && employee.role.name) {
            employee.role.label = roleHelper.getLabel(employee.role.name);
          }
          return employee;
        });
        getMerchant();
      })
      .catch(function() {
        NotificationService.error('Error retrieving merchant employees');
      })
      .finally(function() {
        vm.isLoading = false;
      });
  }

  function getMerchant() {
    vm.isLoading = true;
    merchantService
      .getMerchantById(vm.merchantId)
      .then(function(res) {
        vm.merchant = res.data;
        isAddEmployeeEnabled();
      })
      .catch(function() {
        NotificationService.error('Error getting merchant data');
      })
      .finally(function() {
        vm.isLoading = false;
      });
  }

  function isAddEmployeeEnabled() {
    var activeEmployees = vm.employees.filter(function(employee) {
      return employee.active;
    });
    vm.addEmployeeEnabled = !(vm.merchant.productIds.indexOf(MERCHANT_PRODUCTS.FREE_PLUS) > -1 && activeEmployees.length >= 1);
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/employees/employees.controller.js